var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 70,
    viewBox: "0 0 86.000000 59.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,59.000000) scale(0.100000,-0.100000)",
    fill: "#ee1e12",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178 429 c-15 -8 -18 -25 -18 -94 0 -83 1 -85 26 -91 21 -5 24 -11 20 -30 -4 -13 -5 -24 -2 -24 2 0 29 11 60 25 51 23 69 25 194 25 94 0 142 4 150 12 7 7 12 43 12 90 0 66 -3 79 -19 88 -26 13 -400 13 -423 -1z m122 -83 c0 -16 -19 -25 -37 -18 -23 8 -14 32 12 32 15 0 25 -6 25 -14z m114 5 c9 -13 -19 -32 -38 -25 -17 6 -20 16 -9 27 9 10 41 9 47 -2z m116 -5 c0 -8 -6 -16 -12 -19 -18 -6 -50 12 -43 24 10 15 55 11 55 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 314 c0 -96 4 -94 -180 -94 -96 0 -160 -4 -160 -10 0 -21 45 -30 160 -30 85 0 131 -4 157 -15 44 -19 47 -19 40 -1 -4 9 2 17 14 21 17 6 19 16 19 85 0 68 -3 81 -19 90 -30 15 -31 14 -31 -46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.a06634149d8cba5dda86b0e1d97a157d.svg";
export { ForwardRef as ReactComponent };